import React from "react";
import { ReactAdapter } from "./ReactAdapter";
import { withIntlRootProvider } from "./withIntlRootProvider";

export function withReactAdapter<P>(Component: React.ForwardRefExoticComponent<P> | React.ComponentType<P>) {
    // eslint-disable-next-line prefer-arrow-callback
    return React.forwardRef<ReactAdapter<P>, P & { __bypassReactAdapter?: boolean }>(function Adapted(props, ref) {
        const { __bypassReactAdapter, ...rest } = props;
        return __bypassReactAdapter ? (
            <Component {...(rest as P)} ref={ref} />
        ) : (
            <ReactAdapter {...rest} component={withIntlRootProvider(Component)} ref={ref} />
        );
    });
}
